import ProgressFlashcardComponent from '@views/userCertifications/progress/questions/show';
import FlashcardComponent from '@views/userCertifications/flashcards/show';

export default [
  {
    path: '/certifications',
    component: () => import('@views/userCertifications/index'),
    name: 'userCertifications#index',
    meta: {
      resourceOptional: true,
    },
  },
  {
    path: '/certification',
    component: () => import('@views/userCertifications/show'),
    name: 'userCertifications#show',
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/certification/progress',
    component: () => import('@views/userCertifications/progress'),
    name: 'userCertifications#progress',
    meta: {
      header: true,
    },
  },
  {
    path: '/certification/progress/flashcards/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'userCertifications#progress#flashcard',
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/certification/:categoryId/:userCertificationId/flashcards/:flashcardId?',
    name: 'userCertifications#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
];
